"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(require("underscore"));

var _jquery = _interopRequireDefault(require("jquery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var animate = function animate(el, alert, options) {
  options = options || {};
  var delay = options.delay || 1500;
  var text = el.html();
  el.find('.ladda-label').addClass('hide-span');
  el.append('<i class="fa icon-approve mark-v-on-button"></i>');
  alert ? alert.toggleClass('hide', false) : '';
  setTimeout(function () {
    el.html('<span class="mark-v-on-button-in">' + text + '</span>');

    if (alert) {
      alert.toggleClass('hide', true).fadeOut();
    }
  }, delay);
};

var _default = {
  animate: animate
};
exports.default = _default;